// Module
var code = "<unresponsive-patients></unresponsive-patients>";
// Exports
var _module_exports =code;;
var path = 'app/views/users/gp-letters/tabs/unresponsive-patient/unresponsive-patients.component.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;